<script>
import Layout from '@layout/main'
import SectionRowItem from './components/SectionRowItem'
import SectionNewsItem from './components/SectionNewsItem'
import setWindowHistory from '@utils/window-history'
import { getDefaultBrand } from '@utils/zerone-get-default'
import { brandOptions } from '@utils/zerone-options'
import DialogLogin from '@components/Dialog/Login'
import DialogDealer from '@components/Dialog/Dealer'
import DialogDealerGroup from '@components/Dialog/DealerGroup'
import { authComputed } from '@store/helpers'

const DEFAULT_SEARCH = {
  brand: '',
  month: '',
  query: '',
}
export default {
  page() {
    return {
      title: `最新消息`,
    }
  },
  components: {
    Layout,
    SectionRowItem,
    SectionNewsItem,
    DialogLogin,
    DialogDealer,
    DialogDealerGroup,
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      },
    },
    pagination: {
      type: Object,
      default: () => {
        return {}
      },
    },
    topList: {
      type: Array,
      default: () => {
        return []
      },
    },
    brandOptions: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      isDialogLoginVisible: false,
      isDialogDealerVisible: false,
      isDialogDealerGroupVisible: false,
      callbackLogin: () => {},
      activeName: this.$route.params.categoryAlias || 'promotion',
      searchData: {
        brand: getDefaultBrand(this.$route.query.brand, this.brandOptions) || DEFAULT_SEARCH.brand,
        month: this.$route.query.month || DEFAULT_SEARCH.month,
        query: this.$route.query.query || DEFAULT_SEARCH.query,
      },
      searchList: [
        {
          width: '28%',
          type: 'select',
          placeholder: '所有品牌',
          name: 'brand',
          options: brandOptions(this.brandOptions),
        },
        {
          width: '20%',
          type: 'month',
          placeholder: '不限時間',
          name: 'month',
          clearable: true,
        },
        {
          type: 'text',
          placeholder: '請輸入關鍵字',
          name: 'query',
        },
      ],
      newsList: this.list || [],
      newsPagination: this.pagination || {},
      featuredList: this.topList || [],
      loadingFetchNewsList: false,
      isShowFilterMenu: false,
    }
  },

  computed: {
    ...authComputed,
    formattedList() {
      return this.newsList.map((item) => ({
        title: item.title,
        publish_up: item.publish_up,
        description: item.description,
        brands: item.brands[0],
        introimage: item.introimage,
        extrafields: item.extrafields,
        to: {
          name: 'news-item',
          params: {
            brandAlias: this.$route.query.brand || (item.brands[0] && item.brands[0].alias),
            categoryAlias: item.category_alias.split('/')[1],
            newsAlias: item.alias,
          },
        },
        isdealer: item.extrafields.dealer_only.value === '1',
      }))
    },
    newsBanner() {
      return this.$route.params.categoryAlias === 'promotion' ? require('@assets/images/news/promotion_banner.png') : require('@assets/images/news/bulletin_banner.png')
    },
    hasFilter() {
      if (Object.keys(this.$route.query).length) {
        return Object.keys(this.$route.query).some((key) => {
          return this.$route.query[key] !== undefined
        })
      } else {
        return false
      }
    },
  },
  methods: {
    onChangePage() {
      this.loadingFetchNewsList = true
      this.$router.replace({
        name: this.$route.name,
        params: {
          categoryAlias: this.activeName,
        },
      })
    },
    onSubmit(data) {
      setWindowHistory({
        query: {
          // ...this.$route.query,
          page: 1,
        },
      })
      this.tryToFetchNewsList({
        storeParams: {
          // ...this.$route.params,
          page: 1,
        },
      }).then(() => {
        this.isShowFilterMenu = false
      })
    },
    onChangePagination(page) {
      this.tryToFetchNewsList({
        storeParams: {
          // ...this.$route.params,
          page,
        },
      }).then(() => {
        const url = new URL(window.location)
        let params = url.searchParams
        if (params.has('page')) {
          this.$scrollToElement({
            $el: this.$refs['sectionList'].$el,
            offset: 270,
          })
        }
      })
    },
    async tryToFetchNewsList({ storeParams } = {}) {
      this.loadingFetchNewsList = true
      const params = {
        // ...this.searchData,
        search_date: this.searchData.month,
        brand_alias: this.searchData.brand ? [this.searchData.brand] : '',
        search: this.searchData.query,
        page: this.$route.query.page,
        limit: 10,
        ...storeParams,
      }
      await this.$store
        .dispatch('article/fetchList', {
          contentAlias: this.$route.params.categoryAlias,
          params,
        })
        .then(({ items, pagination, featured }) => {
          const setData = () => {
            this.newsList = items
            this.newsPagination = pagination
            // this.featuredList = featured
          }

          setData()
        })
        .finally(() => {
          this.loadingFetchNewsList = false
        })
    },
    onClearSearch() {
      Object.keys(this.searchData).forEach((key) => {
        this.searchData[key] = undefined
      })
      setWindowHistory({
        query: {
          ...this.$route.query,
          ...this.searchData,
          page: 1,
        },
      })
      this.tryToFetchNewsList({
        storeParams: {
          page: 1,
        },
      })
    },
    // onOpenSearch() {

    // },
    onOpenFilter(status) {
      this.isShowFilterMenu = status
    },
    goToView(item) {
      const loggedInFn = () => {
        this.isDialogLoginVisible = false
        this.$nextTick(() => {
          if ((item.isdealer && this.currentMember?.groupId !== 6) || !this.currentMember?.dealerValidate || this.currentMember?.dealerExpired) {
            this.isDialogDealerGroupVisible = true
          } else {
            this.$router.push(item.to)
          }
        })
      }

      if (this.loggedIn) {
        loggedInFn()
      } else {
        this.callbackLogin = () => {
          loggedInFn()
        }
        this.isDialogDealerVisible = true
      }
    },
    showLogin(val) {
      this.isDialogLoginVisible = val
      this.isDialogDealerVisible = false
    },
  },
}
</script>
<template>
  <Layout>
    <BaseBanner :title="$route.params.categoryAlias === 'promotion' ? '促銷訊息' : '品牌新訊'" :image="newsBanner" class="d-md-block d-none" custom-class="isStyleWhite" />
    <BaseBanner title="最新消息" :image="newsBanner" class="d-md-none" @openFilter="onOpenFilter(!isShowFilterMenu)" />
    <el-tabs v-model="activeName" class="d-md-none d-block isStyleBase isStyleMobileNews" stretch @tab-click="onChangePage">
      <el-tab-pane label="促銷訊息" name="promotion"></el-tab-pane>
      <el-tab-pane label="品牌新訊" name="bulletin"></el-tab-pane>
    </el-tabs>
    <div v-if="hasFilter || list.length || topList.length" v-loading="loadingFetchNewsList">
      <SectionRowItem v-if="featuredList.length" :list="featuredList" @goTo="goToView" />
      <div class="SectionNewsItem section">
        <div class="container">
          <BaseSearchBar
            v-model="searchData"
            :list="searchList"
            :submit-text="`搜尋${$route.params.categoryAlias === 'promotion' ? '促銷訊息' : '品牌新訊'}`"
            :is-show-filter="isShowFilterMenu"
            @search="onSubmit"
            @openFilter="onOpenFilter(false)"
          />
          <div v-if="hasFilter || newsList.length">
            <SectionNewsItem ref="sectionList" :list="formattedList" :pagination="newsPagination" @clearSearch="onClearSearch" @changePagination="onChangePagination" @goTo="goToView" />
          </div>
          <BaseNull v-else is-search-null @clearSearch="onClearSearch" />
        </div>
      </div>
    </div>
    <div v-else class="container section">
      <BaseNull content="<p class='my-0'>目前此頁面尚無建置資料</p>"> </BaseNull>
    </div>
    <DialogDealerGroup :visible.sync="isDialogDealerGroupVisible" />
    <DialogDealer :visible.sync="isDialogDealerVisible" @isShowlogin="showLogin" />
    <DialogLogin :visible.sync="isDialogLoginVisible" @login="callbackLogin" />
  </Layout>
</template>
